import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProjectCard = ({ project, onViewDetails }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Em Andamento':
        return 'text-success bg-success/10';
      case 'Pausado':
        return 'text-warning bg-warning/10';
      case 'Concluído':
        return 'text-primary bg-primary/10';
      case 'Atrasado':
        return 'text-error bg-error/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getProgressColor = (progress) => {
    if (progress >= 80) return 'bg-success';
    if (progress >= 60) return 'bg-primary';
    if (progress >= 40) return 'bg-warning';
    return 'bg-error';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-modal transition-all duration-200">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="font-semibold text-lg text-card-foreground mb-2">
            {project?.name}
          </h3>
          <p className="text-sm text-muted-foreground mb-3">
            {project?.description}
          </p>
          <div className="flex items-center space-x-4 text-sm text-muted-foreground">
            <div className="flex items-center">
              <Icon name="Calendar" size={16} className="mr-1" />
              <span>Início: {project?.startDate}</span>
            </div>
            <div className="flex items-center">
              <Icon name="Clock" size={16} className="mr-1" />
              <span>Prazo: {project?.endDate}</span>
            </div>
          </div>
        </div>
        <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(project?.status)}`}>
          {project?.status}
        </span>
      </div>
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-card-foreground">Progresso</span>
          <span className="text-sm font-semibold text-card-foreground">{project?.progress}%</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div 
            className={`h-2 rounded-full transition-all duration-300 ${getProgressColor(project?.progress)}`}
            style={{ width: `${project?.progress}%` }}
          />
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4 text-sm text-muted-foreground">
          <div className="flex items-center">
            <Icon name="Users" size={16} className="mr-1" />
            <span>{project?.teamSize} técnicos</span>
          </div>
          <div className="flex items-center">
            <Icon name="ClipboardList" size={16} className="mr-1" />
            <span>{project?.activeOrders} OS ativas</span>
          </div>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onViewDetails(project)}
          iconName="ArrowRight"
          iconPosition="right"
        >
          Ver Detalhes
        </Button>
      </div>
    </div>
  );
};

export default ProjectCard;